import React from 'react';
import customElementBoolAttr from '../utils/customElementBoolAttr';

interface ToggleMenuItemProps {
  value: boolean;
  setValue: (val: boolean) => void;
  children: React.ReactNode;
}

const ToggleMenuItem: React.FC<ToggleMenuItemProps> = ({
  value,
  setValue,
  children,
}) => {
  return (
    <aha-menu-item
      onClick={() => {
        setValue(!value);
      }}
    >
      <label>
        <span>{children}</span>
        <aha-switch active={customElementBoolAttr(value)} />
      </label>
    </aha-menu-item>
  );
};

export default ToggleMenuItem;
